export const SHARE_SOCIETE_POINTS = 50
export const SHARE_SOCIETE_POINTS_EARN_KEY = 'pt=all&c=offersharedQ9x2L'
